import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

type UseCloudTalkRealtimeOptions = {
  enabled?: boolean;
  onChange?: () => void;
};

/** Push-style refresh when CloudTalk tables change in Supabase. */
export function useCloudTalkRealtime(options: UseCloudTalkRealtimeOptions = {}) {
  const { enabled = true, onChange } = options;

  usePostgresChangesRealtime({
    enabled,
    channelName: 'dem-cloudtalk-live',
    portalKind: 'dem',
    syncSecondaryAuth: true,
    debounceMs: 200,
    onChange,
    listens: [
      { schema: 'data_entry_management', table: 'missed_calls_tracking' },
      { schema: 'data_entry_management', table: 'cloudtalk_logs' },
      { schema: 'data_entry_management', table: 'cloudtalk_agents' },
      { schema: 'data_entry_management', table: 'cloudtalk_live_calls' },
      { schema: 'data_entry_management', table: 'cloudtalk_call_insights' },
      { schema: 'data_entry_management', table: 'cloudtalk_contacts' },
    ],
  });
}
